import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogSize } from '@bo-client/shared/constants/mat-dialog-size';
import { GenericTwoOptionsModalComponent } from '@bo-client/shared/modals/generic-two-options-modal/generic-two-options-modal.component';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ActionWithMoreInfoModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { ShowErrorModel } from '@bo-client/shared/form-errors/errors-form-model';

@Component({
  selector: 'app-form-confirmation',
  templateUrl: './form-confirmation.component.html',
  styleUrls: ['./form-confirmation.component.scss']
})
export class FormConfirmationComponent implements OnInit, OnDestroy {
  @Input() actions: ActionWithMoreInfoModel[] = [];
  @Input() actionConfirm: string;
  @Input() textConfirm = 'Bestätigen';
  @Input() textReject = 'Ablehnen';
  @Input() actionReject: string;
  @Input() errorFormList: ShowErrorModel[];
  @Input() hideError: boolean = false;
  @Input() message: string;
  @Output() onActionClickedEvent = new EventEmitter<any>();

  private compUnsubs$ = new Subject<void>();

  constructor(public matDialog: MatDialog) {}

  ngOnInit(): void {}

  accept() {
    this.onActionClickedEvent.emit(this.actions[this.actions.findIndex((x) => x.action === 'checkIfErrors')]);
    setTimeout(() => {
      if (this.errorFormList && this.errorFormList.length > 0) {
        return;
      } else {
        this.confirmAccept();
      }
    }, 500);
  }

  confirmAccept() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'form-confirmation-component';
    dialogConfig.maxHeight = MatDialogSize.maxHeight;
    dialogConfig.width = MatDialogSize.width;
    dialogConfig.data = {
      title: 'Bestätigen?',
      message: this.message,
      optionA: 'Abbrechen',
      optionB: this.textConfirm
    };
    const modalDialog = this.matDialog
      .open(GenericTwoOptionsModalComponent, dialogConfig)
      .afterClosed()
      .pipe(takeUntil(this.compUnsubs$))
      .subscribe(
        (result) => {
          if (result) {
            if (result === 'optionA') {
            }
            if (result === 'optionB') {
              this.onActionClickedEvent.emit(
                this.actions[this.actions.findIndex((x) => x.action === this.actionConfirm)]
              );
            }
          }
        },
        (error) => {}
      );
  }

  reject() {
    this.onActionClickedEvent.emit(
      this.actions[this.actions.findIndex((x) => x.action === this.actionReject)]
    );
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
